<form [formGroup]="threadGroupForm">
    <div class="row">
        <div class="col">
            <label for="" *ngIf="readTestcase?.loadTestType === 'WEB'"> User Count : </label>
            <label for="" *ngIf="readTestcase?.loadTestType === 'API' || readTestcase?.loadTestType === 'GRAPHQL'"> Concurrent Users : </label>
            <input placeholder="User Count" class="form-control form-control-sm" type="number" min="1"
                formControlName="noOfUsers" />
        </div>
        <div class="col">

            <div>
                <label class="mr-2">
                    <input type="radio" id="duration" formControlName="iteration" [value]="false"
                        checked="!threadGroupForm.value.iteration" /> Duration
                    (min)
                </label>
                <label>
                    <input type="radio" id="iteration" formControlName="iteration" [value]="true" />
                    Iteration
                </label>

                <input class="form-control form-control-sm" type="number" formControlName="duration"
                    placeholder="Duration" *ngIf="!threadGroupForm.value.iteration" />
                <input class="form-control form-control-sm" type="number" formControlName="iterationCount"
                    placeholder="Iteration" *ngIf="threadGroupForm.value.iteration" />
            </div>
        </div>
        <div class="col">
            <label>Ramp-Up Time (sec) : </label>
            <input placeholder="Ramp-Up Time" class="form-control form-control-sm" type="number" min="0"
                formControlName="rampUp" />
        </div>
    </div>
</form>
<div *ngIf="errorDiv" class="mt-2">
    <div class="text-danger"> {{errorMessage}} </div>

</div>
<div class="modal-footer" style="border-top: none;">
    <button type="submit" class="btn btn-primary btn-sm" (click)="saveConfiguration()" *ngIf="!edited"
        [disabled]="threadGroupForm.invalid"> Add Configuration </button>
    <button type="submit" class="btn btn-primary btn-sm" (click)="updateConfiguration()" *ngIf="edited"
        [disabled]="threadGroupForm.invalid"> Update Configuration </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancelThreadGroupCreation()">Cancel</button>
</div>